<template>
	<vxe-modal ref="setModal" title="设置" :mask="false" :show-zoom="false" :resize="false" :lock-view="false" showFooter>
		<template slot="default">
			<div class="flex flex_column">
				<div class="setlock flex flex_column">
					<label class="title">打印</label>
					<vxe-radio name="n1" v-model="radio" label="M10" content="下载M10桌面版">
					</vxe-radio>
					<label class="point">
					</label>
					<vxe-radio name="n1" v-model="radio" label="WebHtml" content="网页打印"></vxe-radio>
					<label class="point">
					</label>
					<vxe-radio name="n1" v-model="radio" label="socket" content="插件打印"></vxe-radio>
					<label class="point">
					</label>
				</div>
				<div class="setlock" v-if="!type||String(type)!='1'">
					<label class="title">主题色</label>
					<colorset @setConplete="$emit('setConplete')"></colorset>
				</div>
			</div>
		</template>
		<template #footer>
			<el-button @click="clickload" type="primary" v-show="showLoad">下载</el-button>
			<el-button @click="confirm" type="primary" :loading="setloading" :disabled="setloading">设置</el-button>
			<el-button @click="close">取消</el-button>
		</template>
	</vxe-modal>
</template>

<script>
	var Action = {
		M10: {
			download: true, //下载
			autoinstall: false, //自动注册
			url: '/DownLoadFile/M10.txt',
			name: 'M10'
		},
		WebHtml: {
			open: true //打开页面
		},
		socket: {
			download: true, //下载
			autoinstall: true, //自动注册
			url: '/DownLoadFile/printCilen.msi',
			name: 'printSerivce'
		}
	}
	import {
	AboutProject
} from '../../public/static/AboutProject.js';
	export default {
		name: 'printset',
		data() {
			return {
				radio: '',
				setloading:false
			}
		},
		props: ['type'],
		computed: {
			showLoad() {
				// console.log(Action,this.radio,Action[this.radio])
				if (Action[this.radio])
					return Action[this.radio]['download'];
				else return false;
			}
		},
		methods: {
			open() {
				this.setValue();
				this.$refs.setModal.open()
			},
			close() {
				this.$refs.setModal.close()
			},
			confirm() {
				// localStorage.setItem('printset', this.radio);
				try{
					if(this.radio=='socket'){
						this.setloading=true;
						this.$BH().commit('print.checkPrepar',{
							callback:(res)=>{
								this.setloading=false;
								if(res=='err') this.$BH().message("打印插件还未准备好，请检查是否下载安装");
								if(res=='success'){
									//下载安装后重新进行点击
									this.$store.commit('appendUserInfo', {
										_printset: this.radio
									});
									this.$BH().message('设置成功')
								}
							}
						})
					}else{
						//下载安装后重新进行点击
						this.$store.commit('appendUserInfo', {
							_printset: this.radio
						});
						this.$BH().message('设置成功')
					}
				}catch(e){
					//TODO handle the exception
					this.$BH().message(e);
				}
				
			},
			clickload() {
				if (Action[this.radio] && Action[this.radio]['download'])
					window.open(`${AboutProject.ApiUrl}${Action[this.radio]['url']}`)
					// this.download(Action[this.radio]['url'], Action[this.radio]['name']);
			},
			download(url, name) {
				var link = document.createElement('a');
				link.download = name
				link.style.display = 'none';
				link.href = url;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},
			setValue() {
				//打印方法默认设置
				var printset = this.$store.getters.UserInfo._printset;
				if (printset&&(printset == 'M10' || printset == 'WebHtml' || printset == 'socket'))
					this.radio = printset;
				else {
					this.radio = 'WebHtml';
					this.$store.commit('appendUserInfo', {
						_printset: 'WebHtml'
					});
				}
			}
		},
		mounted() {
			this.setValue();
			setTimeout(() => {
				if(this.$refs.setModal)
					this.$refs.setModal.$el.style.setProperty('--zindex', 2001)
			}, 0);
		}
	}
</script>

<style scoped>
	.setlock+.setlock {
		margin-bottom: 10px;
	}

	.setlock .title {
		font-size: 17px;
		font-weight: bold;
		line-height: 50px;
	}

	.point {
		line-height: 30px;
		color: red;
		margin-left: 10px;
	}

	.vxe-radio {
		line-height: 20px;
	}

	.vxe-modal--wrapper {
		z-index: var(--zindex) !important;
	}
</style>
